// axios
import axios from 'axios';
import Vue from 'vue';

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: 'https://some-domain.com/api/',
  // timeout: 1000,
  headers: {
    digest: 'f83aba04d6f5f306a6c58fb41a2ea00a22114800120326994676956c5545ccb50942ad1e142c7558c907ac9ec0bdb21edce7cb0b804b9745b6b7fb8297d20a3d',
    tokeninfo: 'tkQIeSePISqTeWZHM7PreqmqhFBKF0xgCqWQr+IaoLkdenbKB/UFR+pLk7OE4kOC/hYmcliZiGBE1Fze0Fa6gCWUD0F1whPMsY24R9v9X2nDjXNBOMIyonYVjG+aOoUIZx/eb09tpLE4RHdGa1L5Az/vbEChmyzxIhOkCWtVkoglvNt7/g1JbZNUD6kdfV7y'
  }
});

Vue.prototype.$http = axiosIns;

export default axiosIns;
